// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "discovery-assets/css/" + chunkId + "." + {"5957":"dc008875","7709":"3836ebcc","8437":"e9548b38"}[chunkId] + ".chunk.css";
};